<template>
  <div class="modal barbers-modal" id="barber-popup">
    <span
      class="overlay"
      @click="$emit('close-barbers-pop')"
    ></span>
    <div class="slider-wrapper">

      <Carousel
        class = "modal-block"
        :perPageCustom = "[[1, 1]]"
        :speed = "800"
        :navigationEnabled = "true"
        :navigationNextLabel = "''"
        :navigationPrevLabel = "''"
        :loop = "true"
        :navigateTo = navigationNum
      >
        <!-- A -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/ovcharenko.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/ovcharenko.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.A') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Alast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Adesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>

        <!-- B -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/mylik.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/mylik.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.B') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Blast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Bdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>

        <!-- C -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/andreev.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/andreev.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.C') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Clast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Cdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>

        <!-- D -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/patlan.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/patlan.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.D') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Dlast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Ddesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>

        <!-- E -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/shinkarenko.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/shinkarenko.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.E') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Elast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Edesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>

        <!-- F -->

        <!-- G -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/popovich.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/bryantsev.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.G') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Glast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Gdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>

        <!-- H -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/kniupa.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/kniupa.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.H') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Hlast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Hdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>


        <!-- I -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/kovalenko.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/kovalenko.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.I') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Ilast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Idesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>

        <!-- J -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/bogoboyashy.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/bogoboyashy.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.J') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Jlast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Jdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>

        <!-- K -->
        <Slide>
          <div class="inner">
            <div class="barber-back">
              <span
                :style="{'background-image': 'url(' + require('@/content/barbers/babiy.png') + ')'}"
              ></span>
            </div>
            <div class="left">
              <img src="@/content/barbers/babiy.png" />
            </div>
            <div class="right desk">
              <h2>{{ $t('BarbersBlock.Barbers.K') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Klast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Kdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">Appointer</span> -->
              </a>
            </div>
          </div>
        </Slide>


      </Carousel>

      <div
        class="modal-close"
        @click="$emit('close-barbers-pop')"
      >
        <span>{{ $t('Modal.Close') }}</span>
        <img class="c0" src="@/i/modal/close-0.svg">
        <img class="c1" src="@/i/modal/close-1.svg">
        <img class="c2" src="@/i/modal/close-2.svg">
        <img class="c3" src="@/i/modal/close-3.svg">
        <img class="c4" src="@/i/modal/close-4.svg">
      </div>

    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'barbers-block',
  data() {
    return {
    }
  },
  props: [
    'navigationNum'
  ],
  components: {
    Carousel,
    Slide
  },
  methods: {
  },
  mounted () {
  }
}
</script>
